(function() {
  // Wait for window load to ensure DOM and scripts are ready
  window.addEventListener('load', () => {
    console.log('[OpenImageFeatures] Initializing...');

    // Initialize Lucide icons with retry
    function initLucideIcons(attempts = 3, delay = 500) {
      if (window.lucide && typeof lucide.createIcons === 'function') {
        try {
          lucide.createIcons();
          console.log('[OpenImageFeatures] Lucide icons initialized.');
        } catch (e) {
          console.error('[OpenImageFeatures] Lucide icon initialization failed:', e);
        }
      } else if (attempts > 0) {
        console.warn('[OpenImageFeatures] Lucide not ready, retrying in', delay, 'ms...');
        setTimeout(() => initLucideIcons(attempts - 1, delay * 2), delay);
      } else {
        console.error('[OpenImageFeatures] Lucide library not loaded. Check script inclusion.');
      }
    }

    initLucideIcons();

    // Select toggles and circles
    const toggles = document.querySelectorAll('.feature-toggle');
    const circles = document.querySelectorAll('.number-circle');

    console.log('[OpenImageFeatures] Found', toggles.length, 'toggles and', circles.length, 'circles.');

    if (toggles.length === 0) {
      console.error('[OpenImageFeatures] No .feature-toggle elements found. Check HTML structure.');
      return;
    }

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        console.log('[OpenImageFeatures] Toggle clicked:', toggle);

        const featureId = toggle.parentElement.dataset.featureId;
        const content = document.getElementById(`feature-content-${featureId}`);
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (!content) {
          console.error('[OpenImageFeatures] Content not found for featureId:', featureId);
          return;
        }

        // Close all other contents
        document.querySelectorAll('.feature-content.active').forEach(activeContent => {
          activeContent.classList.remove('active');
          activeContent.style.display = 'none';
        });
        document.querySelectorAll('.feature-toggle[aria-expanded="true"]').forEach(activeToggle => {
          activeToggle.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.number-circle.active').forEach(activeCircle => {
          activeCircle.classList.remove('active');
        });

        // Toggle current content
        if (!isExpanded) {
          content.style.display = 'block';
          content.classList.add('active');
          toggle.setAttribute('aria-expanded', 'true');
          const circle = document.querySelector(`.number-circle[data-number-id="${featureId}"]`);
          if (circle) {
            circle.classList.add('active');
            console.log('[OpenImageFeatures] Highlighted circle for featureId:', featureId);
          } else {
            console.warn('[OpenImageFeatures] Circle not found for featureId:', featureId);
          }
        }
      });
    });
    const firstToggle = toggles[0];
if (firstToggle) {
  const featureId = firstToggle.parentElement.dataset.featureId;
  const content = document.getElementById(`feature-content-${featureId}`);
  const circle = document.querySelector(`.number-circle[data-number-id="${featureId}"]`);

  firstToggle.setAttribute('aria-expanded', 'true');
  content.style.display = 'block';
  content.classList.add('active');
  if (circle) {
    circle.classList.add('active');
  }
}
  });
})();